import { Button, Icon } from '@firesoon/antd';
import React from 'react';
import './index.less';
import classNames from 'classnames';

// closeHeight
const Action = ({ toggle, visible, text, positon }) => {
  const [open, close] = text;
  return (
    <Button
      type="link"
      className={classNames('fs-more-search', `fs-more-search-${positon}`)}
      // style={{ lineHeight: `${closeHeight}px` }}
      onClick={() => toggle()}
    >
      {visible ? open : close}
      {visible ? <Icon type="up" /> : <Icon type="down" />}
    </Button>
  );
};

export default Action;
